const ZENO_STATION_PAGE = "https://zeno.fm/radio/radio-frontina/";
const DEFAULT_URL = "https://stream.zeno.fm/hsamfyrv008uv";

const parseStreamFromPage = (html: string): string | null => {
  const match = html.match(
    /<script type="application\/json" data-nuxt-data="nuxt-app"[^>]*>(.*?)<\/script>/
  );
  if (!match) return null;
  try {
    const raw = JSON.stringify(JSON.parse(match[1]));
    const urlMatch = raw.match(/https?:\/\/stream\.zeno\.fm\/([^"'\s\\]+)/);
    return urlMatch ? urlMatch[0] : null;
  } catch {
    return null;
  }
};

const CORS_PROXIES = [
  (url: string) => `https://api.allorigins.win/raw?url=${encodeURIComponent(url)}`,
  (url: string) => `https://corsproxy.io/?${encodeURIComponent(url)}`,
];

const discoverFromZeno = async (): Promise<string | null> => {
  for (const buildProxyUrl of CORS_PROXIES) {
    try {
      const res = await fetch(buildProxyUrl(ZENO_STATION_PAGE), {
        signal: AbortSignal.timeout(5000),
      });
      if (!res.ok) continue;
      const html = await res.text();
      const url = parseStreamFromPage(html);
      if (url) return url;
    } catch {
      continue;
    }
  }
  return null;
};

export const getStreamUrl = async (firebaseStream?: any): Promise<string> => {
  if (firebaseStream?.id) return firebaseStream.id;

  const cached = localStorage.getItem("zeno_stream_url");
  if (cached) return cached;

  const discovered = await discoverFromZeno();
  if (discovered) {
    localStorage.setItem("zeno_stream_url", discovered);
    return discovered;
  }

  return DEFAULT_URL;
};
